<template>
  <div :class="$style.root">
    <div
      :class="[$style.mainSections, { [$style.hasRightContent]: $slots.right }]"
      :style="$slots.right ? { gridTemplateColumns: `${leftWidth} auto` } : undefined"
    >
      <div class="flex flex-col w-full pe-component-padding-small">
        <slot />
      </div>
      <slot name="right" />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ leftWidth?: string }>(), { leftWidth: "385px" });
</script>

<style module lang="scss">
.root {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: max-content auto;

  .mainSections {
    height: 100%;
    width: 100%;
    display: grid;

    // Default width lives here (existing consumers with no right slot are unaffected either way);
    // an instance using the right slot can narrow it via the leftWidth prop, applied inline above
    // since a plain SCSS default can't be overridden per-instance.
    &.hasRightContent {
      grid-template-columns: 385px auto;
    }
  }
}
</style>
